<template>
  <div>
    <v-data-table :headers="headers" :items="listLaws" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }" v-if="item.id">
            <router-link :to="{ name: 'Edit Law', params: { lawId: item.id }}">
              <v-icon color="black" dark v-bind="attrs" v-on="on">mdi-pencil</v-icon>
            </router-link>
          </template>
          <span>Edit</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon dark color="black" v-bind="attrs" v-on="on"
              @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <router-link :to="{name: 'Add Law', params: { appId: this.$route.params.appId }}">
      <v-btn fab color="cyan accent-2" bottom right fixed>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'ListLaws',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Name',
          align: 'center',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('law/getLaws', {
      appId: this.$route.params.appId,
    });
  },
  computed: {
    listLaws() {
      return this.$store.state.law.laws;
    },
  },
  methods: {
    deleteItem(item) {
      // eslint-disable-next-line no-alert
      if (window.confirm('Are you sure?')) {
        this.$store.dispatch('law/delete', {
          appId: this.$route.params.appId,
          lawId: item.id,
        });
      }
    },
  },
};
</script>
